export default __webpack_public_path__ + "static/media/linkedin.a4d56531.svg";